import styled from 'styled-components';

const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--header-size);
  box-sizing: border-box;
`;

export default BoxHeader;
